export default __webpack_public_path__ + "static/media/NerdzOG.4086f28c.png";